import { fixedEncodeURIComponent } from '@shared/lib/utils/fixedEncodeURIComponent';
export function getContentDisposition(filename) {
    return `attachment; filename="${fixedEncodeURIComponent(filename
    // eslint-disable-next-line
    )}"; filename*=utf-8\'\'${fixedEncodeURIComponent(filename)}`;
}
